import { v4 as uuidv4 } from 'uuid';
import { AppDispatch } from "../../state/store";
import { Address } from "../../interfaces/user";
import { fetchUserProfileData } from "../../state/slices/userProfileSlice";
// import { Order, items } from "../../interfaces/user";
// import { clearCart } from "../../state/slices/cartSlice";
// import { ApolloClient } from '@apollo/client';
import { CREATE_ADDRESS,DELETE_ADDRESS,UPDATE_ADDRESS } from '../userMutation';
import client from '../../graphql/client';
import { NavigateFunction } from 'react-router-dom';
import { INITIATE_PHONEPE } from '../orderMutation';
import { log } from 'console';
// import { useDispatch, useSelector } from 'react-redux';


export const placeOrder = async (
  selectedAddress: Address | null,
  currentUser: any,
  cart: any,
   products: any[],
  dispatch: AppDispatch,
  navigate: NavigateFunction,
  setOrderPlaced: (value: boolean) => void,
  setIsProcessing: (value: boolean) => void
) => {
  if (!selectedAddress || !currentUser || !cart || cart.items.length === 0) return;

  try {
    setIsProcessing(true);
    const transactionId = uuidv4();

    const variables = {
      userId: currentUser.id,
      amount: parseFloat(cart.totalPrice.toFixed(2)),
      status: 'pending',
      orderType: "online",
      paymentGateway: "PhonePe",
      transactionId,
      items: cart.items.map((item: any) => ({
        productId: item.productId,
        quantity: item.quantity,
        price: parseFloat(item.price.toFixed(2)),
      })),
      addressId: selectedAddress.id,
    };

    const { data } = await client.mutate({
      mutation: INITIATE_PHONEPE,
      variables,
    });
console.log("PhonePe Initiation Response:", data);
    console.log(data);

    if (!data?.initiatePhonePe?.redirectUrl) {
      throw new Error("Failed to initiate PhonePe payment");
    }

    // dispatch(clearCart(currentUser.id));
    // setOrderPlaced(true);

    // Redirect to PhonePe
    const redirectUrl = data?.initiatePhonePe?.redirectUrl;
    const orderId = data?.initiatePhonePe?.orderId; 
    const mtransactionId = data?.initiatePhonePe?.merchantTransactionId;

    localStorage.setItem("orderId", orderId);
    localStorage.setItem("merchantTxnId", mtransactionId);// ⚠️ match backend field name

    // if (!redirectUrl || !orderId) {
    //   throw new Error("Missing redirect URL or order ID");
    // }

    // ✅ Append orderId to return URL
    const url = new URL(redirectUrl);
    url.searchParams.set("orderId", orderId);

    console.log("Final Redirect URL:", url.toString());

    // 🚀 Redirect
    window.location.href = url.toString();



  } catch (error) {
    console.error("Order placement failed:", error);
    alert("Order placement failed. Please try again.");
  } finally {
    setIsProcessing(false);
  }
};


// export const placeOrder = async (
//   selectedAddress: Address | null,
//   currentUser: any,
//   cart: any,
//   products: any[],
//   dispatch: AppDispatch,
//   navigate: NavigateFunction,
//   setOrderPlaced: (value: boolean) => void,
//   setIsProcessing: (value: boolean) => void,
// ) => {
//   if (!selectedAddress || !currentUser || !cart || cart.items.length === 0) return;

//   try {
//     setIsProcessing(true);

//     // Simulate payment processing delay
//     await new Promise(resolve => setTimeout(resolve, 1500));
//     const transactionId = uuidv4();

//     const variables = {
//       userId: currentUser.id,
//       totalAmount: parseFloat(cart.totalPrice.toFixed(2)),
//       status: 'pending',
//       orderType: 'online',
//       paymentGateway: 'Stripe',
//       transactionId,
//       items: cart.items.map((item: any) => ({
//         productId: item.productId,
//         quantity: item.quantity,
//         price: parseFloat(item.price.toFixed(2)),
//       })),
//       addressId: selectedAddress.id,
//     };

//     const response = await client.mutate({
//       mutation: CREATE_ORDER_WITH_PAYMENT,
//       variables,
//     });

//     const createdOrder = response?.data?.createOrderWithPayment?.order;

//     if (!createdOrder?.id) {
//       throw new Error("Order not created or ID missing");
//     }

//     dispatch(clearCart(currentUser.id));
//     setOrderPlaced(true);

//     setTimeout(() => {
//      navigate(`/user/trackorders/${currentUser.id}?refresh=${Date.now()}`);

//     }, 2000);


//   } catch (error) {
//     console.error('Order placement failed:', error);
//     alert('Order placement failed. Please try again.');
//   } finally {
//     setIsProcessing(false);
//   }
// };




export const addAddress = async (
  newAddress: { city: string; state: string; country: string; postalCode: string; addressLine1?: string; addressLine2?: string } ,
  currentUser: any,
  dispatch: AppDispatch,
  setErrors: (errors: Record<string, string>) => void,
  setNewAddress: (address: any) => void,
  setActiveTab: (tab: number) => void,
  setSelectedAddress: (address: Address) => void,
  setIsProcessing: (isProcessing: boolean) => void
) => {
  // Validation
 const validateAddress = () => {
  const newErrors: Record<string, string> = {};
  if (!newAddress.addressLine1?.trim()) newErrors.addressLine1 = 'Address Line 1 is required';
  if (!newAddress.city.trim()) newErrors.city = 'City is required';
  if (!newAddress.postalCode.trim()) newErrors.postalCode = 'Postal code is required';
  else if (!/^\d{6}$/.test(newAddress.postalCode)) newErrors.postalCode = 'Invalid postal code';
  return newErrors;
};


  const errors = validateAddress();
  if (Object.keys(errors).length > 0) {
    setErrors(errors);
    return;
  }

  if (!currentUser) return;

  try {
    setIsProcessing(true);

    const { data } = await client.mutate({
      mutation: CREATE_ADDRESS,
      variables: {
        userId: currentUser.id,
        addressLine1: newAddress.addressLine1?.trim(),
        addressLine2: newAddress.addressLine2?.trim() || null,
        city: newAddress.city.trim(),
        state: newAddress.state?.trim() || null,
        country: newAddress.country.trim(),
        postalCode: newAddress.postalCode.trim(),
        isDefault: false,
      }
    });

    const savedAddress = data?.createAddress;
    if (savedAddress) {
      dispatch(fetchUserProfileData(currentUser.id));
      setSelectedAddress(savedAddress);
      setNewAddress({
        city: '',
        state: '',
        country: 'India',
        postalCode: ''
      });
      setActiveTab(1);
    } else {
      alert('Something went wrong. No address returned.');
    }
  } catch (error: any) {
    console.error('GraphQL error:', error);
    alert('Failed to add address. Please try again.');
  } finally {
    setIsProcessing(false);
  }
};
export const setDefaultAddress = async (
  address: Address,
  currentUser: any,
  dispatch: AppDispatch,
  setIsProcessing: (processing: boolean) => void,
  setSelectedAddress: (address: Address) => void
) => {
  if (!currentUser || !address) return;

  try {
    setIsProcessing(true);

    const { data } = await client.mutate({
      mutation: UPDATE_ADDRESS,
      variables: {
        id: address.id,
        isDefault: true
      }
    });

    const updatedAddress = data?.updateAddress;
    if (updatedAddress) {
      dispatch(fetchUserProfileData(currentUser.id));
      setSelectedAddress(updatedAddress);
    } else {
      alert('Failed to update default address.');
    }
  } catch (error: any) {
    console.error('GraphQL Error:', error);
    alert('Could not set default address. Please try again.');
  } finally {
    setIsProcessing(false);
  }
};

export const deleteAddress = async (
  addressId: string,
  currentUser: any,
  dispatch: AppDispatch
) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this address?");
  if (!confirmDelete) return;

  try {
    await client.mutate({
      mutation: DELETE_ADDRESS,
      variables: { id: addressId }
    });

    dispatch(fetchUserProfileData(currentUser.id)); // ✅ Refresh data
  } catch (error) {
    console.error("Failed to delete address:", error);
    alert("Something went wrong while deleting the address.");
  }
};
